import React from "react";

class InputField extends React.Component {
  render() {
    return (
      <input
        type={this.props.field.type}
        name={this.props.field.name}
        id={this.props.field.id}
        className={this.props.field.class}
        required={this.props.field.required ? "required" : ""}
        pattern={this.props.field.pattern}
        min={this.props.field.min}
        max={this.props.field.max}
        minLength={this.props.field.minlength}
        maxLength={this.props.field.maxlength}
        defaultValue={this.props.field.value}
      />
    );
  }
}
class SelectField extends React.Component {
  render() {
    return (
      <select
        name={this.props.field.name}
        id={this.props.field.id}
        className={this.props.field.class}
        required={this.props.field.required}
        defaultValue={this.props.field.value}
      >
        {this.props.field.options.map((option, index) => (
          <option
            key={index}
            value={option.value}
            disabled={
              option.disabled !== undefined && option.disabled ? "disabled" : ""
            }
          >
            {option.label}
          </option>
        ))}
      </select>
    );
  }
}

export { InputField, SelectField };
